import catalog from './catalog.json';

const aliases = {
  search: 'search',
  'search-left': 'search',
  add: 'add',
  plus: 'add',
  'plus-circle': 'add',
  'plus-square': 'add',
  edit: 'edit',
  edit2: 'edit',
  edit3: 'edit',
  trash: 'delete',
  'trash-2': 'delete',
  copy: 'content_copy',
  x: 'close',
  'arrow-left': 'arrow_back',
  'arrow-right': 'arrow_forward',
  'chevron-down': 'keyboard_arrow_down',
  'chevron-up': 'keyboard_arrow_up',
  'more-vertical': 'more_vert',
  'more-vertical-1': 'more_vert',
  'refresh-cw': 'refresh',
  'rotate-ccw': 'history',
  download: 'download',
  printer: 'print',
  eye: 'visibility',
  'eye-off': 'visibility_off',
  settings: 'settings',
  users: 'group',
  'user-sidebar': 'group',
  user: 'person',
  factory: 'factory',
  box: 'package_2',
  inventory_2: 'inventory_2',
  zap: 'bolt',
  'check-circle': 'check_circle',
  'alert-triangle': 'warning',
  'x-octagon': 'error',
  info: 'info',
  play: 'play_arrow',
  sort: 'sort',
  filter: 'filter_list',
  calendar: 'calendar_today',
  'external-link': 'open_in_new',
  'checkbox-check': 'check_box',
  'checkbox-checked': 'check_box',
  'checkbox-box': 'check_box_outline_blank',
  'metric-oee': 'monitoring',
  'metric-availability': 'schedule',
  'metric-performance': 'speed',
  'metric-quality': 'verified',
  'analytics-overview': 'dashboard',
  'analytics-efficiency': 'donut_large',
  'analytics-response-time': 'timer',
  'donut-large': 'donut_large',
  stopwatch: 'timer',
  output: 'conveyor_belt',
  shifts: 'calendar_clock',
  'job-orders': 'assignment',
  losses: 'report',
  'serial-numbers': 'qr_code_scanner',
  rubric: 'fact_check',
  'shopping-bag': 'category',
  calculate: 'tune',
  'loss-reasons': 'rule',
  spc: 'show_chart',
  'receipt-long': 'checklist',
  checklists: 'checklist',
  integrations: 'hub',
  webhooks: 'webhook',
  'developer-tools': 'code',
  'api-keys': 'key',
  'chat-bot': 'notifications',
  'company-data': 'domain',
  templates: 'file_copy',
  'motion-photos-auto': 'wand_stars',
  speedometer: 'speed',
  clock: 'schedule',
};

// Intrinsic view boxes take precedence over obsolete caller dimensions.
export function resolveIcon(name) {
  const definition = catalog[aliases[name]];
  if (!definition) {
    return null;
  }

  const [data, viewBox = '0 0 24 24'] = definition.split('|');
  const [x, y, width, height] = viewBox.split(' ').map(Number);

  return {
    viewBox,
    bounds: { x, y, width, height },
    paintPath: `M${x} ${y}h${width}v${height}h${-width}Z`,
    paintStrokeWidth: Math.max(width, height),
    paths: data.split('&&').map((path) => {
      const [d, style] = path.split('@@');

      return {
        d,
        style: style
          ? style.replace('stroke:currentColor', 'stroke:white')
          : 'fill:white;stroke:none',
      };
    }),
  };
}
